module.exports = __webpack_public_path__ + "60b99b5933c803798c1a7d5ed3dbf567.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_30.jpg
// module id = 1775
// module chunks = 5